import React from "react";
import OrderLeftCard from "./OrderLeftCard";
import OrderRightContent from "./OrderRightContent";

const Order = () => {
  return (
    <div
      style={{
        display: "flex",
      }}
    >
      <div
        style={{
          width: 336,
          // height: 648,
          background: "#FFF",
        }}
      >
        <OrderLeftCard />
      </div>

      <div style={{ marginLeft: 30 }}>
        <OrderRightContent />
      </div>
    </div>
  );
};

export default Order;
